 export const openInNewTab = (url: string) => {
    window.open(url, "_blank"); // Opens in a new tab
  };